import { FinalValueValues, FinalValueResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

export function calculateFinalValue(values: FinalValueValues, t?: ToolsTranslations['finalValue']): FinalValueResult {
  const { startingAmount, percentageGrowth } = values;

  if (startingAmount < 0) return { finalAmount: null, isValid: false, message: t?.invalid.startingAmount };
  if (percentageGrowth < -100) return { finalAmount: null, isValid: false, message: t?.invalid.percentageGrowth };

  const finalAmount = Math.round((startingAmount * (1 + percentageGrowth / 100)) * 100) / 100;
  
  if (!isFinite(finalAmount)) return { finalAmount: null, isValid: false, message: t?.invalid.generic };

  return { finalAmount, isValid: true };
}
